module.exports = __webpack_public_path__ + "img/ultra_2_02.3a9937f8.jpg";